import React from "react";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const containerStyle = css`
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
`;

const stampStyle = css`
    position: absolute;
    bottom: -0.5em;
    right: -1.8em;
    pointer-events: none;
    color: #ffd23f;
    background-color: rgba(0, 0, 0, 0.75);
    border: 0.12em solid #ffd23f;
    border-radius: 0.25em;
    padding: 0.15em 0.5em;
    font-family: 'NotoSans';
    font-weight: bold;
    letter-spacing: 0.15em;
    text-shadow:
        -0.08em -0.08em 0 #000,
        0.08em -0.08em 0 #000,
        -0.08em 0.08em 0 #000,
        0.08em 0.08em 0 #000;
    transform: rotate(-14deg);
`;

interface ExperimentalStampProps {
    /** Sized to the button it marks - the default suits a full size UIButton. */
    fontSize?: string;
    /** Set by emotion when a caller passes a css prop, so margins can live on the wrapper */
    className?: string;
    children: React.ReactNode;
}

export const ExperimentalStamp = (props: ExperimentalStampProps) => (
    <div className={props.className} css={containerStyle}>
        {props.children}
        <span css={css`${stampStyle}; font-size: ${props.fontSize ?? '1vw'};`}>EXPERIMENTAL</span>
    </div>
);
